import Vue from 'vue';
import Router from 'vue-router';
import home from '../pages/home.vue';
import dataEnergy from "../components/dataEnergy.vue";
import scene from "../pages/scene/scene.vue";
import sceneSon from "../pages/scene/sceneSon.vue";
import timing from "../pages/scene/timing.vue";
import timingSon from "../pages/scene/timingSon.vue";
import data from "../components/data.vue";
import sceneTlink from "../pages/scene/sceneTlink.vue";
import sceneTlinkSon from "../pages/scene/sceneTlinkSon.vue";
import dataShow from "../pages/hs/dataShow.vue";
import tlinkTjcf from "../pages/scene/tlinkTjcf.vue";
import tlinkTjcfSon from "../pages/scene/tlinkTjcfSon.vue";
import tlinkTjys from "../pages/scene/tlinkTjys.vue";
import tlinkTjysSon from "../pages/scene/tlinkTjysSon.vue";
import tlinkTjtime from "../pages/scene/tlinkTjtime.vue";
import tlinkTjtimeSon from "../pages/scene/tlinkTjtimeSon.vue";
import imgGl from "../pages/hs/imgGl.vue";
import noticeGl from "../pages/hs/noticeGl.vue";
import resvGl from "../pages/hs/resvGl.vue";
import userGl from "../pages/hs/UserGl.vue";
import resvSet from "../pages/hs/resvSet.vue";
import ActivityGl from "../pages/hs/ActivityGl.vue";
import ActivityGlSon from "../pages/hs/ActivityGlSon.vue";
import noticeGlSon from '../pages/hs/noticeGlSon.vue';
import imgGlSon from '../pages/hs/imgGlSon.vue';
import resvSetSon from '../pages/hs/resvSetSon.vue';
import userGlSon from '../pages/hs/userGlSon.vue';
import advice from '../pages/hs/advice.vue';
import adviceSon from '../pages/hs/adviceSon.vue';
import ActivityEvaluate from '../pages/hs/ActivityEvaluate.vue';
import ctrDb from "../components/mem/ctrDb.vue";
import ctrDbShow from "../components/mem/ctrDbShow.vue";
import log from '../pages/logs/log.vue';
import logUser from '../pages/logs/logUser.vue';
import logDev from '../pages/logs/logDev.vue';
import logScene from '../pages/logs/logScene.vue';
import logTiming from '../pages/logs/logTiming.vue';
import glDb from '../pages/gls/glDb.vue';
import glDevList from '../pages/gls/glDevList.vue';
import glArea from '../pages/gls/glArea.vue';
import glAreaGrp from '../pages/gls/glAreaGrp.vue';
import glHouse from '../pages/gls/glHouse.vue';
import glDev from '../pages/gls/glDev.vue';
import glDevErr from '../pages/gls/glDevErr.vue';
import glDevListSon from '../pages/gls/glDevListSon.vue';
import glDevSonLd from '../pages/gls/glDevSonLd.vue';
import glDevSonAir from '../pages/gls/glDevSonAir.vue';
import glDevSonTemp from '../pages/gls/glDevSonTemp.vue';
import glDevSonSon from '../pages/gls/glDevSonSon.vue';
import glUser from '../pages/gls/glUser.vue';
import glUserSon from '../pages/gls/glUserSon.vue';
import login from '../pages/login.vue';
import resvSeeGl from '../pages/hs/resvSeeGl.vue';
import resvGlAdd from '../pages/hs/resvGlAdd.vue';
import resvTxSet from '../pages/hs/resvTxSet.vue';
import glWx from "../pages/gls/glWx.vue";
import orderList from '../pages/mall/orderList.vue';
import orderReview from '../pages/mall/orderReview.vue';
import orderListSon from '../pages/mall/orderListSon.vue';
import shopsDown from '../pages/mall/shopsDown.vue';
import shopsInfo from '../pages/mall/shopsInfo.vue';
import shopsSon from '../pages/mall/shopsSon.vue';
import shopsUp from '../pages/mall/shopsUp.vue';
import orderCount from '../pages/mall/orderCount.vue';

Vue.use(Router);

export default new Router({ /*配置路由跳转页面*/
  // mode: 'history',
  mode:'hash',routes:[
    {
      path:'/',name:'login',component:login
    },
    {
      path:'/ctrDbShow',name:'ctrDbShow',component:ctrDbShow
    },
    {
      path:'/home',  /*配置子页面时需要隐藏 name:'home'*/
      component:home,children:[
        {path:'',name:'',component:glDevList},
        {path:'data',name:'data',component:data},
        {path:'glArea',name:'glArea',component:glArea},
        {path:'glAreaGrp',name:'glAreaGrp',component:glAreaGrp},
        {path:'glHouse',name:'glHouse',component:glHouse},
        {path:'glDev',name:'glDev',component:glDev},
        {path:'ctrDb',name:'ctrDb',component:ctrDb},
        {path:'glDevErr',name:'glDevErr',component:glDevErr},
        {path:'glDevList',name:'glDevList',component:glDevList},
        {path:'glDevListSon',name:'glDevListSon',component:glDevListSon},
        {path:'glDevSonLd',name:'glDevSonLd',component:glDevSonLd},
        {path:'glDevSonAir',name:'glDevSonAir',component:glDevSonAir},
        {path:'glDevSonTemp',name:'glDevSonTemp',component:glDevSonTemp},
        {path:'glDevSonSon',name:'glDevSonSon',component:glDevSonSon},
        {path:'glDb',name:'glDb',component:glDb},
        {path:'dataEnergy',name:'dataEnergy',component:dataEnergy},
        {path:'glUser',name:'glUser',component:glUser},
        {path:'glUserSon',name:'glUserSon',component:glUserSon},
        {path:'glWx',name:'glWx',component:glWx},
        {path:'scene',name:'scene',component:scene},
        {path:'sceneSon',name:'sceneSon',component:sceneSon},
        {path:'timing',name:'timing',component:timing},
        {path:'timingSon',name:'timingSon',component:timingSon},
        {path:'sceneTlink',name:'sceneTlink',component:sceneTlink},
        {path:'sceneTlinkSon',name:'sceneTlinkSon',component:sceneTlinkSon},
        {path:'tlinkTjcf',name:'tlinkTjcf',component:tlinkTjcf},
        {path:'tlinkTjcfSon',name:'tlinkTjcfSon',component:tlinkTjcfSon},
        {path:'tlinkTjys',name:'tlinkTjys',component:tlinkTjys},
        {path:'tlinkTjysSon',name:'tlinkTjysSon',component:tlinkTjysSon},
        {path:'tlinkTjtime',name:'tlinkTjtime',component:tlinkTjtime},
        {path:'tlinkTjtimeSon',name:'tlinkTjtimeSon',component:tlinkTjtimeSon},

        {path:'orderCount',name:'orderCount',component:orderCount},
        {path:'orderList',name:'orderList',component:orderList},
        {path:'orderListSon',name:'orderListSon',component:orderListSon},
        {path:'orderReview',name:'orderReview',component:orderReview},
        {path:'shopsDown',name:'shopsDown',component:shopsDown},
        {path:'shopsInfo',name:'shopsInfo',component:shopsInfo},
        {path:'shopsSon',name:'shopsSon',component:shopsSon},
        {path:'shopsUp',name:'shopsUp',component:shopsUp},

        {path:'hsDataShow',name:'hsDataShow',component:dataShow},
        {path:'hsImgGl',name:'hsImgGl',component:imgGl},
        {path:'hsImgGlSon',name:'hsImgGlSon',component:imgGlSon},
        {path:'hsActivityGl',name:'hsActivityGl',component:ActivityGl},
        {path:'hsActivityGlSon',name:'hsActivityGlSon',component:ActivityGlSon},
        {path:'hsActivityEvaluate',name:'hsActivityEvaluate',component:ActivityEvaluate},
        {path:'hsNoticeGl',name:'hsNoticeGl',component:noticeGl},
        {path:'hsNoticeGlSon',name:'hsNoticeGlSon',component:noticeGlSon},
        {path:'hsResvGl',name:'hsResvGl',component:resvGl},
        {path:'hsResvGlAdd',name:'hsResvGlAdd',component:resvGlAdd},
        {path:'hsResvSeeGl',name:'hsResvSeeGl',component:resvSeeGl},
        {path:'hsUserGl',name:'hsUserGl',component:userGl},
        {path:'hsUserGlSon',name:'hsUserGlSon',component:userGlSon},
        {path:'hsAdvice',name:'hsAdvice',component:advice},
        {path:'hsAdviceSon',name:'hsAdviceSon',component:adviceSon},
        {path:'hsResvSet',name:'hsResvSet',component:resvSet},
        {path:'hsResvSetSon',name:'hsResvSetSon',component:resvSetSon},
        {path:'hsResvTxSet',name:'hsResvTxSet',component:resvTxSet},
        {
          path:'log',  /*配置子页面时需要隐藏name*/
          component:log,children:[
            {path:'',name:'',component:logUser},
            {path:'logUser',name:'logUser',component:logUser},
            {path:'logDev',name:'logDev',component:logDev},
            {path:'logScene',name:'logScene',component:logScene},
            {path:'logTiming',name:'logTiming',component:logTiming}
          ]
        }
      ]
    }
  ]
});

/*隐藏Router报错警示*/
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this,location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js